import { useEffect } from 'react';

/**
 * ElevenLabs ConvAI Widget Component
 * Adds an AI conversation widget to the website
 */
export function ElevenlabAgent() {
  useEffect(() => {
    // Load ElevenLabs ConvAI widget script
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
    script.async = true;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    // Create widget element
    const widgetElement = document.createElement('elevenlabs-convai');
    widgetElement.setAttribute('agent-id', 'agent_4001ka0bzrz0e1nvq7y0b6qnysny');

    // Add widget to body
    document.body.appendChild(widgetElement);

    // Cleanup function
    return () => {
      // Remove script and widget when component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      if (document.body.contains(widgetElement)) {
        document.body.removeChild(widgetElement);
      }
    };
  }, []);

  // This component doesn't render anything visible in React
  // The widget is added directly to the DOM
  return null;
}
